var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M54.0023 27.9996C58.5247 36.4288 55.1078 44.0599 46.3866 46.3857C44.0599 55.1078 36.4288 58.5239 27.9996 54.0023C19.5704 58.5247 11.9393 55.1078 9.6134 46.3866C0.892172 44.0599 -2.52473 36.4288 1.99774 27.9996C-2.52473 19.5704 0.892172 11.9393 9.6134 9.6134C11.9393 0.892172 19.5704 -2.52473 27.9996 1.99774C36.4288 -2.52473 44.0599 0.892172 46.3857 9.6134C55.1078 11.9393 58.5239 19.5704 54.0023 27.9996Z",
    fill: "var(--fill-0, #C8B3FD)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountBadge);
export default __webpack_public_path__ + "static/media/discount-badge.796d56a8847515e1c2f3ebfed7a7e574.svg";
export { ForwardRef as ReactComponent };